import { useContext, useEffect, useState, useRef } from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import Styles from './styles.module.scss';
import { checkAndRoun } from '../../../../helpers/topicsHelpers';

import Preloader from '../../../Preloader';
import InsiderSvc from '../../../../services/dbServices/InsiderSvc';

import TopInvestorsFiltersContext from '../TopInvestorsFiltersContext';

const cx = classNames.bind(Styles);

export const TopInvestorsDetails = ({ investorData }) => {
  let mounted = true;
  const initialized = useRef(false);

  const [loading, setLoading] = useState(true);
  const {
    valueOfHoldings, investmentsMade, url, stakeholderId,
  } = investorData;
  const { year } = useContext(TopInvestorsFiltersContext);

  const [currentData, setCurrentData] = useState([]);

  useEffect(() => {
    const params = {
      id: stakeholderId,
    };

    InsiderSvc.getCompanySingleInvestor(params)
      .then((res) => {
        if (!mounted) {
          return;
        }
        const { investments } = res || {};
        initialized.current = true;
        setCurrentData(
          (investments || []).slice(0, 3),
        );
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const loadingStyles = {
    height: '200px',
  };

  return (
    <div className={cx('top-investors-details')}>
      {loading ? (
        <Preloader centered loading static style={loadingStyles} color="#fff" />
      ) : (
        <>
          {!currentData.length ? (
            <div className={cx('top-investors-details-no-data')}>
              <div className={cx('top-investors-details-no-data-text')}>
                No data currently available.
              </div>
            </div>
          ) : (
            <>
              <div className={cx('top-investors-details-header')}>
                <div className={cx('top-investors-details-date')}>
                  {year}
                </div>
                <div className={cx('top-investors-details-total')}>
                  Invested
                  &nbsp;
                  <span>
                    £
                    {checkAndRoun(valueOfHoldings, 2, true)}
                  </span>
                </div>
              </div>
              <div className={cx('top-investors-details-body')}>
                <div className={cx('top-investors-details-body-header')}>
                  <div>
                    {investmentsMade}
                    &nbsp;
                    investments
                  </div>
                  <div>
                    GBP mln
                  </div>
                </div>
                <ul className={cx('top-investors-details-list')}>
                  {currentData.map(({companyName, valueOfHoldings }) => (
                    <li className={cx('top-investors-details-list-item')} key={companyName}>
                      <div className={cx('top-investors-details-list-item-name')}>
                        {companyName.length < 16 ? companyName : `${companyName.slice(0, 14)}...`}
                      </div>
                      <div className={cx('top-investors-details-list-item-amount')}>
                        {checkAndRoun(valueOfHoldings, 2, true)}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className={cx('top-investors-details-footer')}>
                {url && (
                  <Link className={cx('top-investors-details-link')} to={url}>See all</Link>
                )}
              </div>
            </>
          )}
        </>
      ) }
    </div>
  );
};

export default TopInvestorsDetails;
